export default function formatDate(inputDate: Date): string {
  const days: string[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]
  const months: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const dayName: string = days[inputDate.getDay()]
  const monthName: string = months[inputDate.getMonth()]
  const numericalDate: number = inputDate.getDate()

  return `${dayName}, ${numericalDate} ${monthName} ${inputDate.getFullYear()}`
}
